module.exports = __webpack_public_path__ + "static/media/kw.7a17a936.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/kw.svg
// module id = 168
// module chunks = 0